import PreEventView from '@src/components/layout/admin/sections/pre-event/pre-event-view';
import React from 'react';

const PreEventViewPage = () => {
    return <PreEventView title="รายละเอียดคำขอกิจกรรม" />;
};

export default PreEventViewPage;
